<template>
    <form class="add-wallpaper" v-bind:action="apiUrl + '/wallpapers'" v-on:submit.prevent="handleSubmit" >
        <div class="form__group" v-bind:class="{ 'has-error' : errors.name }">
            <label class="form__label" for="name">{{ __('Wallpaper name') }}</label>
            <input class="form__control is-large" id="name" type="text" autocomplete="off"
                   v-bind:placeholder="__('Enter wallpaper name')"
                   v-model="name"
            />
            <span class="form__focus"></span>
        </div>
        <small class="form__error" v-if="errors.name">{{ errors.name[0] }}</small>

        <div class="form__group" v-bind:class="{ 'has-error' : errors.file }">
            <file-control accept="image/*" v-bind:label="__('Upload image')" v-model="image" />
        </div>
        <small class="form__error" v-if="errors.file">{{ errors.file[0] }}</small>

        <div class="form__group" v-if="categories && categories.length > 0" v-bind:class="{ 'has-error' : errors.category }">
            <label class="form__label" for="category">{{ __('Category') }}</label>
            <select class="form__control" id="category"
                    v-model="category"
            >
                <option v-for="cat in categories" v-bind:value="cat.id">{{ cat.name }}</option>
            </select>
            <span class="form__focus"></span>
        </div>
        <small class="form__error" v-if="errors.category_id">{{ errors.category_id[0] }}</small>

        <button class="btn is-primary edit-tile__save-btn" type="submit">{{ __('Save') }}</button>
    </form>
</template>

<script>
    import { eventBus } from '../eventBus.js';

    import fileControl from '../elements/FileControl.vue';

    export default {
        components: {
            fileControl
        },
        data: function () {
            return {
                category: null,
                categories: [],
                errors: {},
                image: '',
                name: ''
            }
        },
        methods: {
            getCategories: function () {
                this.categories = [];

                eventBus.$emit('show-loader');

                this.$http.get(this.apiUrl + '/wallpapers/categories', {
                    params : {
                        page: 1,
                        perPage: 0,
                        sortBy: 'name',
                        sortOrder: 'asc'
                    }
                }).then(function (response) {
                    this.categories = response.body.original.data;

                    eventBus.$emit('hide-loader');
                }.bind(this), function (response) {
                    eventBus.$emit(
                        'show-alert',
                        'error',
                        this.__('There was an error retrieving data from the server.')
                    );

                    eventBus.$emit('hide-loader');
                });
            },
            handleSubmit: function (e) {
                const form = e.target;
                const action = form.getAttribute('action');
                const method = 'post';

                eventBus.$emit('show-loader');

                this.$http[method](action, {
                    category_id: this.category,
                    file: this.image,
                    name: this.name,
                    user_id: this.user.id
                }).then(function (response) {
                    eventBus.$emit('hide-loader');

                    eventBus.$emit('show-alert', 'success', this.__('Wallpaper has been successfully saved.'));

                    this.$router.push({
                        name: 'wallpapers'
                    });
                }, function (response) {
                    if (response.status == 422 && response.body.errors) {
                        this.errors = response.body.errors;
                    }

                    eventBus.$emit('hide-loader');

                    eventBus.$emit(
                        'show-alert',
                        'error',
                        this.__('There were some errors validation the form. Please review and correct them.')
                    );
                });
            },
            init: function () {
                this.getCategories();
            }
        },
        mounted: function () {
            this.init();
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/AddWallpaper.vue